
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalBoard as ObiBuoySphericalBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-board.js';
 
 
 

 
 export const ObiBuoySphericalBoard = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-board',
   elementClass: ObiBuoySphericalBoardElement,
   events: {
     
   }
  });
 
 